module.exports = __webpack_public_path__ + "static/media/18ECA24.f0187694.jpg";